import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2561b3',
      light: '#6ea0ff',
    },
    secondary: {
      main: '#000000',
      light: '#484848',
    },
    background: {
      default: '#ffffff',
      paper: '#f4f6f8',
    }
  },
  typography: {
    fontFamily: 'sans-serif',
  },  
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'sans-serif';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
        }
      `,
    },
  },
}); 